import React from "react"
import PropTypes from 'prop-types'
import SelectGenericNew from "../../../../../../../gd-ui/select-generic-new/select-generic-new";
import FieldUser_DropdownValueNotEmpty from "../../../../../../generic/user/components/dropdown/value-not-empty";
import FieldDropdown_PopoverOptionUser from "../../../../../../generic/user/components/option/option-user";
import {FieldAutomationActionFormProps} from "../../../../../../render/automation-action-form";
import {AssigneeStrategy, AssigneeStrategyOptions, MULTI_USER_STRATEGIES} from "../../@const";
import FieldsFactory from "../../../../../../fields-factory";
import {FIELDS} from "../../../../../../fields.const";
import FieldProto from "../../../../../../proto/field-proto";
import SelectMultiGenericNew from "../../../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new";
import FieldUser_MultiselectValueNotEmpty from "../../../../../../generic/user/components/multiselect/value-not-empty";
import FieldUser_MultiselectPopoverOption from "../../../../../../generic/user/components/multiselect/popover-option";

export default class FieldTaskAssignedToUser_AutomationActionForm extends React.Component<FieldAutomationActionFormProps> {

    public strategy     : AssigneeStrategy
    public fieldSingle     : FieldProto
    public fieldMulti     : FieldProto
    public field     : FieldProto

    public toValue      : any
    public toValues      : any

    static propTypes = {
        field           : PropTypes.object,
        config          : PropTypes.object,

        options         : PropTypes.array,

        onChangeCallback: PropTypes.func,
    }

    constructor(props: FieldAutomationActionFormProps) {
        super(props);

        this.fieldSingle = FieldsFactory.get(
            {
                fieldId                : 'action-assigned',
                type                   : FIELDS.TASK_ASSIGNED_TO,
                currentUserValueOption : true
            }
        )

        this.fieldMulti  = FieldsFactory.get(
            {
                fieldId : 'action-assigned-round-robin',
                type    : FIELDS.USERS
            }
        )

        this.field       = this._isMultiUserStrategy() ? this.fieldMulti : this.fieldSingle
    }



    _isMultiUserStrategy = () => {
        return _.includes(MULTI_USER_STRATEGIES, this.props.config.strategy)
    }

    onChangeToValue     = (option:any)  => {
        this.props.onChangeCallback({
            strategy    : this.props.config.strategy,
            toValue     : option.value,
            toValues    : undefined
        })
    }

    onChangeToValues     = (userIds:any[])  => {

        this.props.onChangeCallback({
            strategy     : this.props.config.strategy,
            toValue      : undefined,
            toValues     : userIds
        })
    }

    onChangeMode = (option: Option) => {
        // this.strategy = option.value as AssigneeStrategy



        this.props.onChangeCallback({
            strategy    : option.value as AssigneeStrategy,
            toValue     : undefined,
            toValues    : undefined
        })

        // if (this._isMultiUserStrategy()) {
        //     this.field   = this.fieldMulti
        //     this.toValue = undefined
        // } else {
        //     this.field    = this.fieldSingle
        //     this.toValues = []
        // }

        // this._reRenderAction?.()
    }

    render() {

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        let userSelector : any

        switch (this.props.config.strategy) {

            case AssigneeStrategy.STRATEGY_BALANCED:
            case AssigneeStrategy.STRATEGY_ROUND_ROBIN:
            case AssigneeStrategy.STRATEGY_RANDOM:

                userSelector = (
                    <SelectMultiGenericNew className                        = "selector w-180 m-l-30"
                                           options                          = {this.props.field.getAutomationOptions()}
                                           values                           = {this.props.config.toValues} // config.toValue is for custom fields
                                           allValuesOptionLabel             = "Any"
                                           popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                           allValuesOption                  = {true}
                                           isSearchable                     = {true}
                                           valueComponent                   = {FieldUser_MultiselectValueNotEmpty}
                                           popoverOptionComponent           = {FieldUser_MultiselectPopoverOption}
                                           disabled                         = {this.props.config.disabled}
                                           onChange                         = {this.onChangeToValues}/>
                )
                break


            case AssigneeStrategy.STRATEGY_USER:
            default:

                userSelector = (
                    <SelectGenericNew className                     = "selector w-180 m-l-30"
                                      options                       = {this.props.field.getAutomationOptions()}
                                      value                         = {this.props.config.toValue}
                                      popoverContainerClasses       = "max-w-200"
                                      popoverScrollContainerClasses = "max-h-200"
                                      valueComponent                = {FieldUser_DropdownValueNotEmpty}
                                      popoverOptionComponent        = {FieldDropdown_PopoverOptionUser}
                                      isSearchable                  = {true}
                                      disabled                      = {this.props.config.disabled}
                                      onChange                      = {this.onChangeToValue}/>
                )
                break
        }

        return (
            <div className="flex-row-left-top">

                <div className="label">to</div>

                <SelectGenericNew className = "selector w-180"
                                  options    = {AssigneeStrategyOptions}
                                  value      = {this.props.config.strategy}
                                  disabled   = {this.props.config.disabled}
                                  onChange   = {this.onChangeMode}/>


                {/*<div className="label w-20"></div>*/}

                {userSelector}




            </div>
        )
    }
}
